import { defineNuxtPlugin, useRuntimeConfig, useHead } from "#app";
export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const prefetchUrls = [
    "https://use.typekit.net/",
    // Fonts
    `${config.public.storageUrl}/`,
    // CDN
    "https://cdn.jsdelivr.net/"
    // PWA workbox
  ];
  useHead({
    link: prefetchUrls.map((url) => [
      {
        rel: "preconnect",
        href: url
      },
      // dns-prefetch hint for browsers that don't support the preconnect
      {
        rel: "dns-prefetch",
        href: url
      }
    ]).flat()
  });
});
